"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWidth = void 0;
var react_1 = require("react");
/** `useWidth` - retrieves windows inner width */
var useWidth = function () {
    var _a = react_1.useState(window.innerWidth), width = _a[0], setWidth = _a[1];
    var handleWindowSizeChange = react_1.useCallback(function () {
        setWidth(window.innerWidth);
    }, []);
    react_1.useEffect(function () {
        window.addEventListener('resize', handleWindowSizeChange);
        return function () {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, [handleWindowSizeChange]);
    return width;
};
exports.useWidth = useWidth;
//# sourceMappingURL=useWidth.js.map